import React from 'react';
import './searchinput.css'
import arrow from './../../../assets/arrow2.svg'
const Input = (props) => {
    return ( <>
    <div className="input">
        <label> {props.label} <img src={arrow} alt="" /></label>
    <input type="text" placeholder={props.placeholder} />
    </div>
    </> );
}
 
export default Input;